<booking-authorisations-mobile *ngIf="isMobile"></booking-authorisations-mobile>
<booking-authorisations-desktop *ngIf="!isMobile"></booking-authorisations-desktop>